import { api } from '../api';

const PAGE_SIZE = 20;

export async function listOrgs({ q = '', page = 1, limit = PAGE_SIZE } = {}) {
  const params = new URLSearchParams();
  params.set('limit', limit);
  params.set('page', page);
  if (q) params.set('q', q);
  return api(`/superadmin/organizations?${params.toString()}`);
}

export async function getOrg(orgId) {
  return api(`/superadmin/organizations/${orgId}`);
}

export async function grantFreeDays(orgId, { days, reason, mode }) {
  return api(`/superadmin/organizations/${orgId}/grant-free-days`, {
    method: 'POST',
    body: JSON.stringify({ days, reason, mode })
  });
}

export async function overridePlan(orgId, { plan, endsAt, reason }) {
  return api(`/superadmin/organizations/${orgId}/override-plan`, {
    method: 'POST',
    body: JSON.stringify({ plan, endsAt, reason })
  });
}

export async function removeOverride(orgId, { reason } = {}) {
  return api(`/superadmin/organizations/${orgId}/override-plan`, {
    method: 'DELETE',
    body: reason ? JSON.stringify({ reason }) : undefined
  });
}

export async function removeGrace(orgId, { reason } = {}) {
  return api(`/superadmin/organizations/${orgId}/grace`, {
    method: 'DELETE',
    body: reason ? JSON.stringify({ reason }) : undefined
  });
}

export async function setTrialEnd(orgId, { endsAt, reason }) {
  return api(`/superadmin/organizations/${orgId}/trial`, {
    method: 'PATCH',
    body: JSON.stringify({ endsAt, reason })
  });
}

export async function createOrg({ name, billing_tier, admin_email, admin_password, admin_name }) {
  return api('/superadmin/organizations', {
    method: 'POST',
    body: JSON.stringify({ name, billing_tier, admin_email, admin_password, admin_name })
  });
}

export async function setPlan(orgId, { plan, reason, seat_limit, trial_days }) {
  return api(`/superadmin/organizations/${orgId}/plan`, {
    method: 'PATCH',
    body: JSON.stringify({ plan, reason, seat_limit, trial_days })
  });
}

export async function cancelSubscription(orgId) {
  return api(`/superadmin/organizations/${orgId}/cancel-subscription`, { method: 'POST' });
}

export async function pauseSubscription(orgId) {
  return api(`/superadmin/organizations/${orgId}/pause-subscription`, { method: 'POST' });
}

export async function resumeSubscription(orgId) {
  return api(`/superadmin/organizations/${orgId}/resume-subscription`, { method: 'POST' });
}

export async function forceSync(orgId) {
  return api(`/superadmin/organizations/${orgId}/force-sync`, { method: 'POST' });
}

export async function getStripeLink(orgId) {
  return api(`/superadmin/organizations/${orgId}/stripe-link`);
}

export async function linkStripe(orgId, { stripe_customer_id, stripe_subscription_id }) {
  return api(`/superadmin/organizations/${orgId}/stripe`, {
    method: 'PATCH',
    body: JSON.stringify({ stripe_customer_id, stripe_subscription_id })
  });
}

export async function extendStripeTrial(orgId, { days, reason }) {
  return api(`/superadmin/organizations/${orgId}/stripe-trial/extend`, {
    method: 'POST',
    body: JSON.stringify({ days, reason })
  });
}

export async function endStripeTrial(orgId, { reason } = {}) {
  return api(`/superadmin/organizations/${orgId}/stripe-trial/end`, {
    method: 'POST',
    body: reason ? JSON.stringify({ reason }) : undefined
  });
}

export async function activateAccess(orgId, { days, reason }) {
  return api(`/superadmin/organizations/${orgId}/activate`, {
    method: 'POST',
    body: JSON.stringify({ days, reason })
  });
}

export async function deactivateAccess(orgId, { reason }) {
  return api(`/superadmin/organizations/${orgId}/deactivate`, {
    method: 'POST',
    body: JSON.stringify({ reason })
  });
}

export async function manualTrial(orgId, { days, reason }) {
  return api(`/superadmin/organizations/${orgId}/trial`, {
    method: 'POST',
    body: JSON.stringify({ days, reason })
  });
}

export async function clearBillingOverride(orgId, { reason } = {}) {
  return api(`/superadmin/organizations/${orgId}/clear-override`, {
    method: 'POST',
    body: reason ? JSON.stringify({ reason }) : undefined
  });
}

export async function extendAccess(orgId, { days, reason }) {
  return api(`/superadmin/organizations/${orgId}/extend`, {
    method: 'POST',
    body: JSON.stringify({ days, reason })
  });
}

export const PAGE_LIMIT = PAGE_SIZE;
